import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'baycare-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'BayCare Concierge Medicine',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1,
  email: '@',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/baycare/index.js